var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHelpSupport = function SvgHelpSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E1F26",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M10.342 9.383c.26-.802 1.11-1.383 2-1.383 1.11 0 2 .914 2 2v.01c0 1.706-2 1.99-2 2.44v.3m0 3.25v.01M5.27 4.929c3.905-3.905 10.237-3.905 14.142 0s3.905 10.237 0 14.142c-3.224 3.224-8.1 3.786-11.902 1.688l-3.582.86a1 1 0 0 1-1.206-1.206l.86-3.582C1.484 13.03 2.047 8.153 5.27 4.929M12.59 16a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0"
  })));
};
export default SvgHelpSupport;